import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import DashboardLayout from "./components/layout/DashboardLayout";
import Overview from "./pages/Overview";
import Services from "./pages/Services";
import Platforms from "./pages/Platforms";
import Campaigns from "./pages/Campaigns";
import Revenue from "./pages/Revenue";
import AiAdvisor from "./pages/AiAdvisor";
import Branches from "./pages/Branches";
import ManagementDashboard from "./pages/ManagementDashboard";
import DailyFunnel from "./pages/DailyFunnel";
import Goals from "./pages/Goals";
import MasterData from "./pages/MasterData";
import { Activity } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0F172A]">
        <Activity className="w-8 h-8 text-[#38BDF8] animate-pulse" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  useEffect(() => { document.documentElement.classList.add("dark"); }, []);
  return (
    <div className="App min-h-screen bg-[#0F172A]">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
              <Route index element={<Overview />} />
              <Route path="services" element={<Services />} />
              <Route path="platforms" element={<Platforms />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="revenue" element={<Revenue />} />
              <Route path="ai" element={<AiAdvisor />} />
              <Route path="branches" element={<Branches />} />
              <Route path="mgmt" element={<ManagementDashboard />} />
              <Route path="daily-funnel" element={<DailyFunnel />} />
              <Route path="goals" element={<Goals />} />
              <Route path="master-data" element={<MasterData />} />
            </Route>
          </Routes>
          <Toaster position="top-right" theme="dark" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
